<template>
    <flex-layout styleClasses="p-24">
        <TableQuery :params="params" :sorts="sorts" :resetFilters="resetFilters" :sortBy="sortBy" />

        <div class="position-relative h-100">
            <absolute-layout :scrollable="true" styleClass="table-responsive">
                <table class="table table-01" width="50%">
                    <thead>
                        <th v-for="item in tableHeading" :key="item.index">
                            {{ item.heading }}
                        </th>

                        <th>Actions</th>
                    </thead>
                    <Spinner v-if="isLoading" />
                    <TableData :tableData="tableData" v-else>
                        <tr v-for="item in tableData" :key="item.index">
                            <td>
                                {{ item.name }}
                            </td>

                            <td>
                                {{ item.email }}
                            </td>
                            <td>
                                <div class="badge rounded-pill"
                                    :class="{ 'bg-red': !item.status, 'bg-green': item.status }">
                                    {{ item.status ? "Active" : "In-Active" }}
                                </div>
                            </td>
                            <td class="action">
                                
                                <button title="Status Toggle" class="btn btn-sm btn-gray" @click="updateStatus(item.id)"
                                    v-if="$can($route.meta.guard + '.delete')">
                                    <i class="ic-lock"></i> Change Status
                                </button>

                                <button title="Change Password" class="btn btn-sm btn-gray" data-bs-toggle="offcanvas"
                                    data-bs-target="#userdetailmodal" aria-controls="offcanvasCreate"
                                    @click.prevent="changePassword(item)" v-if="$can($route.meta.guard + '.update')">
                                    <i class="ic-parking"></i> Change Password
                                </button>

                                <button title="Change Details" class="btn btn-sm btn-gray" data-bs-toggle="offcanvas"
                                    data-bs-target="#userdetailmodal" aria-controls="offcanvasCreate"
                                    @click.prevent="changeDetails(item)" v-if="$can($route.meta.guard + '.update')">
                                    <i class="ic-user-profile-fill"></i> Change Details
                                </button>

                              
                            </td>
                        </tr>
                    </TableData>

                </table>
                <div class="table-footer">
                    <PerPage :options="options" :params="params" />
                    <paginate :page-class="'page-item'" :page-count="pageCount" :page-link-class="'page-link'"
                        :container-class="'pagination  pagination-sm'" :prev-text="`<i class='ic-chevron-left'></i>`"
                        :next-text="` <i class='ic-chevron-right'></i>`" :prev-class="'page-link pagination-arrow mr-2'"
                        :next-class="'page-link pagination-arrow ml-2'" :click-handler="handlePagination"
                        ref="paginate"></paginate>
                </div>
            </absolute-layout>
        </div>

    </flex-layout>
</template>
  

<script>
import AbsoluteLayout from "@/components/Layout/AbsoluteLayout.vue";
import FlexLayout from "@/components/Layout/FlexLayout.vue";
import PaginationMixin from "@/mixins/pagination.vue";
import PerPage from "@/components/Utility/PerPage.vue";
import TableMixin from "@/mixins/table.vue";
import Spinner from "@/components/Utility/Spinner.vue";
import TableQuery from "@/components/Utility/TableQuery.vue";
import TableData from "@/components/Utility/TableData.vue";
import Permissions from "@/mixins/Permissions.vue";

export default {
    name: 'UserTable',
    components: {
        AbsoluteLayout, FlexLayout, PerPage, TableQuery,
        Spinner, TableData
    },
    mixins: [TableMixin, PaginationMixin, Permissions],

    data() {
        return {
            url: 'usermamangement',
            fetch_module: 'FETCH_USERs'
        };
    },
    methods: {
        updateStatus(id) {
            //axios url request
            let uri = this.api_url + this.url + '/toggleStatus';
            this.isLoading = true;
            let item ={};
            item.id = id;
            this.axios.post(uri, item).then((response) => {
                this.isLoading = false;
                this.$toast.success(response.data.message, {
                    position: "bottom-right",
                });
                this.$root.$emit(this.fetch_module);
            }).catch((error) => {
                this.isLoading = false;
                if (error.response) {
                    if (error.response.status == 422) {
                        this.pushErrors(error.response.data.errors);
                        this.$toast.error("An error Occured.", {
                            position: "bottom-right",
                        });
                    }
                }
            });
        },
        changePassword(userData){
            this.$root.$emit("changePassword", userData);
        },
        changeDetails(userData){
            this.$root.$emit("changeDetails", userData);
        }
    },
};
</script>
<style scoped>

</style>
    